import { render } from "./ProjectGroupTable.vue?vue&type=template&id=faa0c0f4&scoped=true&ts=true"
import script from "./ProjectGroupTable.vue?vue&type=script&lang=ts"
export * from "./ProjectGroupTable.vue?vue&type=script&lang=ts"

import "./ProjectGroupTable.vue?vue&type=style&index=0&id=faa0c0f4&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa0c0f4"]])

export default __exports__